import { render } from "./RegisterMemberInfo.vue?vue&type=template&id=5357cdc1"
import script from "./RegisterMemberInfo.vue?vue&type=script&lang=js"
export * from "./RegisterMemberInfo.vue?vue&type=script&lang=js"

import "./RegisterMemberInfo.vue?vue&type=style&index=0&id=5357cdc1&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__